import * as React from 'react';
import { signOut } from 'firebase/auth';
import { AppContextProvider } from 'src/App';
import { auth } from 'src/firebase';
import { ProtectedRoute } from 'src/ProtectedRoute';

export function UserProfile(): JSX.Element {
    const { user } = React.useContext(AppContextProvider);

    if (!user) {
        return (
            <ProtectedRoute>
                <div className="flex-vertical ml-1 mr-1 gap-1">
                    <h2 className="white-text">User Profile</h2>
                    <div className="basic-box">
                        <p className="white-text">Please log in to view your profile.</p>
                    </div>
                </div>
            </ProtectedRoute>
        );
    }

    return (
        <ProtectedRoute>
            <div className="flex-vertical ma-2 gap-1">
                <h2 className="white-text">User Profile</h2>
                <div className="basic-box">
                    <div className="flex gap-1 item-align-center">
                        {user.photoURL && (
                            <img 
                                src={user.photoURL} 
                                alt="Profile" 
                                style={{ borderRadius: '50%', width: '64px', height: '64px' }} 
                            />
                        )}
                        <div>
                            <h3 className="white-text">{user.displayName}</h3>
                            <p className="white-text">{user.email}</p>
                        </div>
                    </div>
                    <div className="mt-1 flex gap-1">
                        <button onClick={() => signOut(auth)}>Sign Out</button>
                    </div>
                </div>
            </div>
        </ProtectedRoute>
    );
}
